import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B11cPaymentTypeSubListPage } from '../b11c-payment-type-sub-list/b11c-payment-type-sub-list';
import { B11PaymentTypeManagementPage } from '../b11-payment-type-management/b11-payment-type-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B11ePaymentTypeSubListInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-b11e-payment-type-sub-list-info',
	templateUrl: 'b11e-payment-type-sub-list-info.html',
})
export class B11ePaymentTypeSubListInfoPage {
	
	private todo : FormGroup;
	loading: any;
	Status: any;
	public errorMessage: any = "";
	
	paymentSubTypeData = { SUB_TYPE:'', PAYMENT_TYPE_ID:'', PAYMENT_SUB_TYPE_ACTIVE:'YES'}
	PAYMENT_SUB_TYPE_ID:any;

	constructor(public navCtrl: NavController, public navParams: NavParams,
				private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
				public loadingCtrl: LoadingController, public alertCtrl : AlertController) {
					
		this.todo = this.formBuilder.group({
			sub_type: ['', Validators.required],
			active: ['', Validators.required],
		});
		this.PAYMENT_SUB_TYPE_ID = this.navParams.get('paramSubPaymentId');
		
		let tbl = ["PAYMENT_SUB_TYPE"];
		let column = ["PAYMENT_SUB_TYPE_ID"];
		let value = [this.PAYMENT_SUB_TYPE_ID];
		
		let tblkey = ["No"];
		let fktbl = ["No"];
		let fkkey = ["No"];
  
		let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
		let mydata = Object.assign(jsonitem);
		let json_data = this.serviceapi.json_readdata(mydata,"1");
		this.showLoader();
		this.serviceapi.readdata(json_data,"PAYMENT_SUB_TYPE","1","1").then((result) => {			
			this.Status = result["Message"];			
			if (this.Status == '1') {
				this.loading.dismiss();				
				let Records = result["Records"];
				this.paymentSubTypeData.SUB_TYPE = Records[0]["SUB_TYPE"];
				this.paymentSubTypeData.PAYMENT_TYPE_ID = Records[0]["PAYMENT_TYPE_ID"];
				this.paymentSubTypeData.PAYMENT_SUB_TYPE_ACTIVE = Records[0]["PAYMENT_SUB_TYPE_ACTIVE"];
				//console.log(this.paymentTypeData);
			}
			else {
				this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
				this.loading.dismiss();
			}
		}, (err) => {
			this.errorMessage = "Loading Error. Please try again.";
			this.loading.dismiss();
		});
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad B11ePaymentTypeSubListInfoPage');
	}
	
	delete() {
		let confirm = this.alertCtrl.create({
			title: 'Confirmation',
			message: 'Are you sure you want to delete this payment sub type? This action cannot be undone.',
			buttons: [
				{
					text: 'No',
					handler: () => {
						//console.log('Disagree clicked');
					}
				},
				{
					text: 'Yes',
					handler: () => {
						//console.log('Agree clicked');
						this.showLoader();
						this.serviceapi.deletedata('PAYMENT_SUB_TYPE', 'PAYMENT_SUB_TYPE_ID', this.PAYMENT_SUB_TYPE_ID).then((result) => {
							this.Status = result["Message"];
							if (this.Status == "1") {
								this.loading.dismiss();
								this.navCtrl.setRoot(B11cPaymentTypeSubListPage, {paramID: this.paymentSubTypeData.PAYMENT_TYPE_ID});
							}
							else {
								this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
								this.loading.dismiss();
							}
						}, (err) => {
							this.errorMessage = "Loading Error. Please try again.";
							this.loading.dismiss();
						});
					}
				}
			]
		});
		confirm.present();
	}
	
	save() {
		//console.log(this.paymentSubTypeData);
		this.serviceapi.updatedata('PAYMENT_SUB_TYPE', 'PAYMENT_SUB_TYPE_ID', this.PAYMENT_SUB_TYPE_ID, this.paymentSubTypeData).then((result) => {
			this.Status = result["Message"];
			if (this.Status == "1") {
				this.loading.dismiss();
				this.navCtrl.setRoot(B11cPaymentTypeSubListPage, {paramID: this.paymentSubTypeData.PAYMENT_TYPE_ID});
			}
			else {
				this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
				this.loading.dismiss();
			}
		}, (err) => {
			this.errorMessage = "Loading Error. Please try again.";
			this.loading.dismiss();
		});
	}
	
	cancel() {
		this.navCtrl.pop();
	}
	
	goTo() {
		this.navCtrl.setRoot(B11PaymentTypeManagementPage);
	}
	
	goTo2() {
		this.navCtrl.setRoot(B11cPaymentTypeSubListPage, {paramID: this.paymentSubTypeData.PAYMENT_TYPE_ID});
	}
	
	showLoader() {
		this.loading = this.loadingCtrl.create({
			content: 'Loading...',
		});
		this.loading.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/b11e-payment-type-sub-list-info/b11e-payment-type-sub-list-info.ts